
import { timeFormat } from "@/utils/time";
import store from "@/store";
import dict from "@/config";

const authStatusFilters = Object.keys(dict.KINSFOLK_STATUS).map(item => {
	return { text: dict.KINSFOLK_STATUS[item], value: item }
})

const studentStatusFilters = Object.keys(dict.STUDENT_STATUS).map(item => {
	return { text: dict.STUDENT_STATUS[item], value: item }
})
const computedAuthStatusText = (kinsflokList) => {
	if (!kinsflokList.length) {
		return "暂无认证";
	}
	if (kinsflokList.find((item) => item.status === "MATCHED")) {
		return "待认证";
	}
	if (kinsflokList.find((item) => item.status === "NO_MATCH")) {
		return "待匹配";
	}
	if (kinsflokList.find((item) => item.status === "DECLINED")) {
		return "已驳回";
	}
	if (kinsflokList.find((item) => item.status === "ACCEPTED")) {
		return "已认证";
	}
	if (kinsflokList.find((item) => item.status === "INVALID")) {
		return "已失效";
	}
	return "未知状态";
};
export const getKlassColumns = () => {
	return [
		{
			title: "班级头像",
			dataIndex: "logo_url",
			align: "center",
			scopedSlots: { customRender: "logo_url" },
		},
		{
			title: "班级",
			dataIndex: "name",
			align: "center",
			sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "学生数量",
			dataIndex: "studentNum",
			align: "center",
			sorter: (a, b) => a.stat.student_count - b.stat.student_count,
			customRender: (text, record) => {
				return record.stat.student_count;
			},
		},
		{
			title: "关联家长数量",
			dataIndex: "kinsfolkNUm",
			align: "center",
			sorter: (a, b) => a.stat.verified_kinsfolk_count - b.stat.verified_kinsfolk_count,
			customRender: (text, record) => {
				return record.stat.verified_kinsfolk_count;
			},
		},
		{
			title: "任教老师",
			dataIndex: "teachers",
			align: "center",
			customRender: (text = []) => {
				return text.map(item => item.name).join("、") || "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};

export const getStudentColumns = () => {
	return [
		{
			title: "学生姓名",
			dataIndex: "kid_name",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "班级信息",
			dataIndex: "klass_id",
			align: "center",
			sorter: (a, b) => a.klass_id.localeCompare(b.klass_id),
			customRender: (text) => {
				const curKlass = store.getters.klassList.find(item => item.id === text) || {};
				return curKlass.name || "--";
			},
		},
		{
			title: "在校状态",
			dataIndex: "status",
			align: "center",
			sorter: (a, b) => a.status.localeCompare(b.status),
			filters: studentStatusFilters,
			onFilter: (value, record) => record.status === value,
			customCell: (record) => {
				return { class: `STUDENT_STATUS_${record.status}` };
			},
			customRender: (text) => {
				return `● ${dict.STUDENT_STATUS[text] || "--"}`;
			},
		},
		{
			title: "性别",
			dataIndex: "gender",
			align: "center",
			sorter: (a, b) => (a.gender || "").localeCompare(b.gender || ""),
			filters: [
				{
					text: "男",
					value: "MALE",
				},
				{
					text: "女",
					value: "FEMALE",
				},
			],
			onFilter: (value, record) => record.gender === value,
			customRender: (text) => {
				return dict.GENDER_MAP[text] || "--";
			},
		},
		{
			title: "出生日期",
			dataIndex: "birth_date",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "注册家长数",
			dataIndex: "kinsfolk_info_from_teacher_list",
			align: "center",
			sorter: (a, b) => a.kinsfolk_info_from_teacher_list.length - b.kinsfolk_info_from_teacher_list.length,
			customRender: (text = []) => {
				return text.length;
			},
		},
		{
			title: "家长认证",
			dataIndex: "authStatus",
			align: "center",
			sorter: (a, b) => computedAuthStatusText(a.kinsfolk_info_from_teacher_list || []).localeCompare(computedAuthStatusText(b.kinsfolk_info_from_teacher_list || [])),
			filters: authStatusFilters,
			onFilter: (value, record) => {
				return record.kinsfolk_info_from_teacher_list.map(item => item.status).includes(value)
			},
			customCell: (record) => {
				const kinsflokList = record.kinsfolk_info_from_teacher_list || [];
				if (kinsflokList.find(item => item.status === "NO_MATCH")) {
					return { class: `AUTH_STATUS_NO_MATCH` };
				}

				if (kinsflokList.find(item => item.status === "MATCHED")) {
					return { class: `AUTH_STATUS_MATCHED` };
				}

				if (kinsflokList.find(item => item.status === "DECLINED")) {
					return { class: `AUTH_STATUS_DECLINED` };
				}

				if (kinsflokList.find(item => item.status === "ACCEPTED")) {
					return { class: `AUTH_STATUS_ACCEPTED` };
				}

				if (kinsflokList.find(item => item.status === "INVALID")) {
					return { class: "AUTH_STATUS_INVALID" };
				}

				return { class: "" };
			},
			scopedSlots: { customRender: "authStatus" },
		},
		{
			title: "入学日期",
			dataIndex: "admission_date",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};

export const getKinsfolkColumns = () => {
	return [
		{
			title: "家长姓名",
			dataIndex: "name",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "家长手机号",
			dataIndex: "mobile",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "学生姓名",
			dataIndex: "kidName",
			align: "center",
			sorter: (a, b) => (a.kidName || "").localeCompare(b.kidName || ""),
			customRender: (text) => {
				return text || "--";
			},
		},
		// {
		// 	title: "宝贝姓名",
		// 	dataIndex: "kid_name",
		// 	align: "center",
		// 	customRender: (text, record) => {
		// 		return record.matched_kinsfolk ?  record.matched_kinsfolk.kid_name : "--";
		// 	},
		// },
		{
			title: "亲属关系",
			dataIndex: "relationship",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "班级信息",
			dataIndex: "klassId",
			align: "center",
			sorter: (a, b) => a.klassId.localeCompare(b.klassId),
			customRender: (text) => {
				const curKlass = store.getters.klassList.find(item => item.id === text) || { klass: {} };
				return curKlass.name || "--";
			},
		},
		{
			title: "认证状态",
			dataIndex: "status",
			align: "center",
			filters: authStatusFilters,
			sorter: (a, b) => a.status.localeCompare(b.status),
			onFilter: (value, record) => record.status === value,
			customCell: (record) => {
				return { class: `AUTH_STATUS_${record.status}` };
			},
			scopedSlots: { customRender: "status" },
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];
};

export const getTeacherColumns = (klassId) => {
	return [
		{
			title: "姓名",
			dataIndex: "name",
			align: "center",
			width: 120,
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "性别",
			dataIndex: "gender",
			align: "center",
			width: 120,
			sorter: (a, b) => (a.gender || "").localeCompare(b.gender || ""),
			filters: [
				{
					text: "男",
					value: "MALE",
				},
				{
					text: "女",
					value: "FEMALE",
				},
			],
			onFilter: (value, record) => record.gender === value,
			customRender: (text) => {
				return dict.GENDER_MAP[text] || "--";
			},
		},
		{
			title: "任教信息",
			dataIndex: "klass",
			align: "center",
			customRender: (text, record) => {
				const teachers = record.teachers || [];
				let klassList = teachers.filter(item => item.klass);
				if (klassId) {
					klassList = klassList.filter(item => item.klass.id === klassId);
				}
				return klassList.map(item => {
					return `${item.klass.name}(${item.role.name})`
				}).join("、");
			},
		},
		// {
		// 	title: "职务",
		// 	dataIndex: "role",
		// 	align: "center",
		// 	customRender: (text, record) => {
		// 		const teachers = record.teachers || [];
		// 		return teachers.map(item => item.role.name).join("、");
		// 	},
		// },
		{
			title: "出生年月",
			dataIndex: "birth_date",
			align: "center",
			width: 120,
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "教资",
			dataIndex: "has_teacher_qualification",
			align: "center",
			width: 120,
			sorter: (a, b) => (a.has_teacher_qualification + "").localeCompare(b.has_teacher_qualification + ""),
			filters: [
				{
					text: "有",
					value: true,
				},
				{
					text: "无",
					value: false,
				},
			],
			onFilter: (value, record) => record.has_teacher_qualification === value,
			customRender: (text) => {
				return text ? "有" : "无";
			},
		},
		{
			title: "职称",
			dataIndex: "professional_title",
			align: "center",
			width: 120,
			sorter: (a, b) => (a.professional_title || "").localeCompare(b.professional_title || ""),
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "入职日期",
			dataIndex: "entry_date",
			align: "center",
			width: 120,
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			width: 200,
			scopedSlots: { customRender: "operation" },
		},
	];
};

export const getSensitiveColumns = () => {
	return [
		{
			title: "信息日期",
			dataIndex: "create_time",
			align: "center",
			width: 120,
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "班级信息",
			dataIndex: "klass_id",
			align: "center",
			width: 120,
			customRender: (text, record) => {
				return record.klass.name || "--";
			},
		},
		{
			title: "敏感词",
			dataIndex: "senstiveWord",
			align: "center",
			width: 120,
			scopedSlots: { customRender: "senstiveWord" },
		},
		{
			title: "文本",
			dataIndex: "content",
			align: "center",
			scopedSlots: { customRender: "content" },
		},
		// {
		// 	title: "操作",
		// 	dataIndex: "operation",
		// 	align: "center",
		// 	width: 200,
		// 	scopedSlots: { customRender: "operation" },
		// },
	];	
}

export const getAdminColumns = () => {
	return [
		{
			title: "姓名",
			dataIndex: "name",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "手机号",
			dataIndex: "mobile",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "职称",
			dataIndex: "professional_title",
			align: "center",
			customRender: (text) => {
				return text || "--";
			},
		},
		{
			title: "入职日期",
			dataIndex: "entry_date",
			align: "center",
			customRender: (text) => {
				return text ? timeFormat(text, "YYYY-MM-DD") : "--";
			},
		},
		{
			title: "操作",
			dataIndex: "operation",
			align: "center",
			scopedSlots: { customRender: "operation" },
		},
	];	
}

export default {
	getKlassColumns,
	getStudentColumns,
	getKinsfolkColumns,
	getTeacherColumns,
	getSensitiveColumns,
	getAdminColumns
};
